<template>
  <div class="detail-box">
    <div class="detail-title">
      <div class="detail-title-big">{{ $route.meta.parentTitle }}</div>
      <div class="detail-title-small">{{ $route.meta.parentTitle }}</div>
    </div>
    <div class="detail-info">
      <div class="detail-info-title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item, index) of humList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-info-title-right">
          <el-input v-model="searchQuery.gjc" clearable placeholder="输入关键词，搜项目、公告、规则…"
            class="input-with-select"></el-input>
          <el-button type="primary" @click="searchList">查询</el-button>
        </div>
      </div>
      <div class="detail-info-content">
        <div class="detail-info-content-silder">
          <div class="detail-info-content-silder-title">项目</div>
          <el-menu :default-active="activeIndex" unique-opened class="el-menu-vertical-demo" :text-color="'#1E1E1E'"
            :active-text-color="'#0C6AEC'" @select="changeCurrentPage">
            <el-submenu index="zczr" class="menu_item">
              <template slot="title">资产转让</template>
              <el-menu-item index="zczr-1">房屋</el-menu-item>
              <el-menu-item index="zczr-2">设备物资</el-menu-item>
              <!-- <el-menu-item index="zczr-3">物资</el-menu-item> -->
              <el-menu-item index="zczr-3">车辆</el-menu-item>
              <el-menu-item index="zczr-4">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="zczl" class="menu_item">
              <template slot="title">资产租赁</template>
              <el-menu-item index="zczl-5">房屋</el-menu-item>
              <!-- <el-menu-item index="zczl-7">土地</el-menu-item> -->
              <el-menu-item index="zczl-6">场地区域</el-menu-item>
              <el-menu-item index="zczl-7">设备</el-menu-item>
              <el-menu-item index="zczl-8">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="zhjy" class="menu_item">
              <template slot="title">综合交易</template>
              <el-menu-item index="zhjy-9">特许经营权</el-menu-item>
              <el-menu-item index="zhjy-10">债权</el-menu-item>
              <el-menu-item index="zhjy-11">数据信息</el-menu-item>
              <el-menu-item index="zhjy-12">专栏</el-menu-item>
            </el-submenu>
            <el-submenu index="nccq" class="menu_item">
              <template slot="title">农村产权</template>
              <el-menu-item index="nccq-13">房屋</el-menu-item>
              <el-menu-item index="nccq-14">土地</el-menu-item>
              <el-menu-item index="nccq-15">设备</el-menu-item>
              <el-menu-item index="nccq-16">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="ygzb" class="menu_item">
              <template slot="title">阳光招标</template>
              <el-menu-item index="ygzb-17">工程项目</el-menu-item>
              <el-menu-item index="ygzb-18">采购项目</el-menu-item>
            </el-submenu>
            <el-menu-item index="zstj" class="menu_item">招商推介</el-menu-item>
            <el-submenu index="cjgs" class="menu_item">
              <template slot="title">成交公示</template>
              <el-menu-item index="cjgs-19">成交公示</el-menu-item>
            </el-submenu>

          </el-menu>
        </div>
        <div class="detail-info-content-list">
          <div class="detail-info-content-list-search">
            <div class="detail-info-content-list-search-item">
              <span class="detail-info-content-list-search-item-title">公告类型：</span>
              <div class="detail-info-content-list-search-item-tag">
                <div v-for="item of gglxList" :key="item.value" @click="changeGglx(item.value)"
                  :class="['detail-info-content-list-search-item-tag-detail', searchQuery.gglx === item.value ? 'active' : '']">
                  {{
                    item.name }}
                </div>
              </div>
            </div>
            <div class="detail-info-content-list-search-item">
              <span class="detail-info-content-list-search-item-title">项目状态：</span>
              <div class="detail-info-content-list-search-item-tag">
                <div v-for="item of xxztList" :key="item.value" @click="changeXxzt(item.value)"
                  :class="['detail-info-content-list-search-item-tag-detail', searchQuery.xxzt === item.value ? 'active' : '']">
                  {{
                    item.name }}
                </div>
              </div>
            </div>
            <div class="detail-info-content-list-search-item">
              <span class="detail-info-content-list-search-item-title">挂牌金额：</span>
              <div class="detail-info-content-list-search-item-tag">
                <div v-for="item of gpjeList" :key="item.value" @click="changeGpje(item.value)"
                  :class="['detail-info-content-list-search-item-tag-detail', searchQuery.gpje === item.value ? 'active' : '']">
                  {{
                    item.name }}
                </div>
              </div>
            </div>
            <div class="detail-info-content-list-search-item">
              <span class="detail-info-content-list-search-item-title">所在地区：</span>
              <div class="detail-info-content-list-search-item-tag">
                <div v-for="item of szdqList" :key="item.value" @click="changeSzdq(item.value)"
                  :class="['detail-info-content-list-search-item-tag-detail', selectedOptions.length === 0 ? 'active' : '']">
                  {{
                    item.name }}
                </div>
                <div class="detail-info-content-list-search-item-tag-city">
                  <el-cascader ref="myCascader" style="width: 100%;" size="small" :props="{
                    checkStrictly: true,
                    emitPath: true
                  }" :options="regionData" v-model="selectedOptions" clearable @change="change"></el-cascader>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-info-content-sort">
            <div class="detail-info-content-sort-left">
              <div class="detail-info-content-sort-left-text">
                共
                <span>{{ total }}</span> 个标
              </div>
              <div class="detail-info-content-sort-left-tab">
                <div :class="['detail-info-content-sort-left-tab-item', searchQuery.mrpx === 1 ? 'active' : '']"
                  @click="changePx('mr')">默认排序</div>
                <div
                  :class="['detail-info-content-sort-left-tab-item', [2, 3].includes(searchQuery.zxpx) ? 'active' : '']"
                  @click="changePx('zx')">
                  最新发布
                  <div class="detail-info-content-sort-left-tab-item-jt">
                    <i :class="['el-icon-caret-top', searchQuery.zxpx === 2 ? 'active-b' : '']"></i>
                    <i :class="['el-icon-caret-bottom', searchQuery.zxpx === 3 ? 'active-b' : '']"></i>
                  </div>
                </div>
                <div
                  :class="['detail-info-content-sort-left-tab-item', [4, 5].includes(searchQuery.jgpx) ? 'active' : '']"
                  @click="changePx('jg')">
                  价格
                  <div class="detail-info-content-sort-left-tab-item-jt">
                    <i :class="['el-icon-caret-top', searchQuery.jgpx === 4 ? 'active-b' : '']"></i>
                    <i :class="['el-icon-caret-bottom', searchQuery.jgpx === 5 ? 'active-b' : '']"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-info-content-sort-right">
              <div class="detail-info-content-sort-right-tab">
                <div @click="changeListType(1)"
                  :class="['detail-info-content-sort-right-tab-item', listType === 1 ? 'active' : '']">
                  <i class="el-icon-menu"></i>
                  卡片
                </div>
                <div @click="changeListType(2)"
                  :class="['detail-info-content-sort-right-tab-item', listType === 2 ? 'active' : '']">
                  <i class="el-icon-s-operation"></i>
                  列表
                </div>
              </div>
            </div>
          </div>
          <div class="detail-info-content-table">
            <template>
              <div v-if="listType === 1" class="detail-info-content-table-card">
                <div class="detail-info-content-table-card-item" v-for="item of tableData" :key="item.xmId"
                  @click="viewDetail(item)">
                  <div class="detail-info-content-table-card-item-img">
                    <img :src="item.tp" alt />
                  </div>
                  <div class="detail-info-content-table-card-item-text">
                    <div class="detail-info-content-table-card-item-text-title">{{ item.bt }}</div>
                    <div class="detail-info-content-table-card-item-text-info">
                      <div class="detail-info-content-table-card-item-text-title-left">挂牌金额：</div>
                      <div class="detail-info-content-table-card-item-text-title-right">
                        <span>{{ item.gpj }}</span> 万元
                      </div>
                    </div>
                    <div class="detail-info-content-table-card-item-text-info">
                      <div class="detail-info-content-table-card-item-text-title-left">报名截止时间：</div>
                      <div class="detail-info-content-table-card-item-text-title-bmjz">{{ item.bmjzsj }}</div>
                    </div>
                    <div class="detail-info-content-table-card-item-text-info">
                      <div class="detail-info-content-table-card-item-text-title-left">报名剩余时间：</div>
                      <div class="detail-info-content-table-card-item-text-title-sysj">{{ item.bmsysj }}</div>
                    </div>
                    <div class="detail-info-content-table-card-item-text-info">
                      <div class="detail-info-content-table-card-item-text-title-left">浏览量：{{ item.readNum }}</div>
                    </div>
                  </div>
                  <div v-if="item.xxzt === 1" class="detail-info-content-table-card-item-button-active">立即报名</div>
                  <div v-else class="detail-info-content-table-card-item-button-unactive">立即报名</div>
                </div>
              </div>
              <el-table v-if="listType === 2" header-cell-class-name="table-header-own" :data="tableData" stripe
                style="width: 100%">
                <el-table-column label="序号" align="center" min-width="60">
                  <template slot-scope="scope">
                    {{ scope.$index + (currentPage - 1) * 10 + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="bt" show-overflow-tooltip label="项目名称" min-width="180"></el-table-column>
                <el-table-column align="center" prop="gpj" label="挂牌金额" min-width="100"></el-table-column>
                <el-table-column align="center" prop="bmjzsj" min-width="100" label="挂牌结束日期"></el-table-column>
                <el-table-column align="center" min-width="80" label="项目状态">
                  <template slot-scope="scope">
                    <div class="table-zt">
                      <span class="table-zt-dot"></span>
                      <div v-if="scope.row.xxzt === 1">正在报名</div>
                      <div v-else-if="scope.row.xxzt === 2">报名已截止</div>
                      <div v-else-if="scope.row.xxzt === 3">正在竞价</div>
                      <div v-else-if="scope.row.xxzt === 4">已成交</div>
                      <div v-else-if="scope.row.xxzt === 5">已终止</div>
                      <div v-else-if="scope.row.xxzt === 6">已撤牌</div>
                      <div v-else>无</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="viewDetail(scope.row)" type="warning" size="small">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <div class="detail-info-content-table-page">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="10"
                layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  provinceAndCityData, //省市二级联动数据,汉字+code
  pcTextArr, //省市联动数据，纯汉字
  regionData, //省市区数据
  pcaTextArr, //省市区联动数据，纯汉字
  codeToText //是个大对象，属性是区域码，属性值是汉字
} from 'element-china-area-data'
export default {
  components: {},
  data() {
    return {
      activeIndex: '',
      gglxList: [
        {
          name: '不限',
          value: ''
        },
        {
          name: '正式公告',
          value: 1
        },
        {
          name: '预公告',
          value: 2
        }
      ],
      xxztList: [
        {
          name: '不限',
          value: ''
        },
        {
          name: '正在报名',
          value: 1
        },
        {
          name: '报名已截止',
          value: 2
        },
        {
          name: '正在竞价',
          value: 3
        },
        // {
        //   name: '已结束',
        //   value: 4
        // },
        {
          name: '已成交',
          value: 4
        },
        {
          name: '已终止',
          value: 5
        },
        {
          name: '已撤牌',
          value: 6
        }
      ],
      gpjeList: [
        {
          name: '不限',
          value: ''
        },
        {
          name: '50万元以下',
          value: 1
        },
        {
          name: '50-500万',
          value: 2
        },
        {
          name: '500-5000万',
          value: 3
        },
        {
          name: '5000万已上',
          value: 4
        }
      ],
      szdqList: [
        {
          name: '不限',
          value: ''
        }
      ],
      searchQuery: {
        gglx: '',
        xxzt: '',
        gpje: '',
        ssq: [],
        mrpx: 1,
        jgpx: '',
        zxpx: '',
        gjc: ''
      },
      regionData, //省市区数据
      selectedOptions: [], //已选中的数据
      tableData: [],
      listType: 1,
      currentPage: 1,
      humList: [],
      total: 0
    }
  },
  watch: {
    $route(to, from) {
      this.humList = to.matched
      this.activeIndex = to.path
        .split('/')
        .filter(item => {
          return item && item !== 'xm'
        })
        .join('-')
      // 在路由变化时执行的操作
      this.getList()
    }
  },
  created() { },
  mounted() {
    this.humList = this.$route.matched
    this.activeIndex = this.$route.path
      .split('/')
      .filter(item => {
        return item && item !== 'xm'
      })
      .join('-')
    this.getList()
  },
  methods: {
    searchList() {
      this.currentPage = 1
      this.getList()
    },
    changeGglx(gglx) {
      this.searchQuery.gglx = gglx
      this.$nextTick(() => {
        this.getList()
      })
    },
    changeXxzt(xxzt) {
      this.searchQuery.xxzt = xxzt
      this.$nextTick(() => {
        this.getList()
      })
    },
    changeGpje(gpje) {
      this.searchQuery.gpje = gpje
      this.$nextTick(() => {
        this.getList()
      })
    },
    changeSzdq(szdq) {
      if (!szdq) {
        this.selectedOptions = []
      }
      this.$nextTick(() => {
        this.getList()
      })
    },
    changePx(px) {
      if (px === 'mr') {
        this.searchQuery.mrpx = 1
        this.searchQuery.zxpx = ''
        this.searchQuery.jgpx = ''
      } else if (px === 'zx') {
        this.searchQuery.mrpx = ''
        if (this.searchQuery.zxpx === '') {
          this.searchQuery.zxpx = 2
        } else if (this.searchQuery.zxpx === 2) {
          this.searchQuery.zxpx = 3
        } else if (this.searchQuery.zxpx === 3) {
          this.searchQuery.zxpx = ''
        }
      } else if (px === 'jg') {
        this.searchQuery.mrpx = ''
        if (this.searchQuery.jgpx === '') {
          this.searchQuery.jgpx = 4
        } else if (this.searchQuery.jgpx === 4) {
          this.searchQuery.jgpx = 5
        } else if (this.searchQuery.jgpx === 5) {
          this.searchQuery.jgpx = ''
        }
      }
      if (this.searchQuery.jgpx === '' && this.searchQuery.zxpx === '') {
        this.searchQuery.mrpx = 1
      }
      this.$nextTick(() => {
        this.getList()
      })
    },
    changeListType(listType) {
      this.listType = listType
    },
    getList() {
      let params = {
        pageNum: this.currentPage,
        category: this.$route.path.split('/')[
          this.$route.path.split('/').length - 1
        ],
        gglx: this.searchQuery.gglx,
        gpje: this.searchQuery.gpje,
        mrpx: this.searchQuery.mrpx,
        zxpx: this.searchQuery.zxpx,
        jgpx: this.searchQuery.jgpx,
        xxzt: this.searchQuery.xxzt,
        gjc: this.searchQuery.gjc,
        province: this.selectedOptions[0] || '',
        city: this.selectedOptions[1] || '',
        district: this.selectedOptions[2] || ''
      }
      if (params.category === 'zstj') {
        params.category = ''
        params.xmtj = 1
      }
      if (params.category === 'ksrk') {
        params.category = ''
        this.searchQuery.gjc = this.$route.query.searchInput
        params.gjc = this.searchQuery.gjc
      }
      this.axios
        .get('https://admin.jshtcq.com/api/sy/xmlistTable', { params })
        .then(res => {
          this.tableData = res.data.rows
          this.total = res.data.total
        })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },

    change() {
      // 关闭下拉菜单
      this.$refs.myCascader.dropDownVisible = false
      this.$nextTick(() => {
        this.getList()
      })
    },
    changeCurrentPage(index) {
      let path = '/xm/' + index.replaceAll('-', '/')
      this.$router.push({
        path: path
      })
    },
    viewDetail(row) {
      this.$router.push({
        path: `/detailInfo/${row.xmId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #409eff;
    color: #0c6aec !important;
  }
}

.detail-box {
  background: #f7f7f7;

  .detail-title {
    width: 100%;
    height: 250px;
    background: url('./../assets/jsht/detail/detail_top_bg.png') left top no-repeat;
    background-size: 100% 100%;
    position: relative;

    .detail-title-big {
      font-family: YouSheBiaoTiHei;
      font-size: 150px;
      color: rgba(0, 101, 240, 0.12);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 195px;
      line-height: 195px;
      margin-top: 16px;
    }

    .detail-title-small {
      font-family: YouSheBiaoTiHei;
      font-size: 52px;
      color: #0c6aec;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 68px;
      line-height: 68px;
      margin-top: 108px;
    }
  }

  .detail-info {
    padding: 0 240px;

    .detail-info-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;

      .detail-info-title-right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .input-with-select {
          width: 300px;
          margin-right: 12px;
        }
      }
    }

    .detail-info-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .detail-info-content-silder {
        width: 220px;
        // background: #ffffff;

        .detail-info-content-silder-title {
          height: 52px;
          background: #0c6aec;
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 52px;
          text-align: center;
        }
      }

      .detail-info-content-list {
        flex: 1;
        margin-left: 12px;

        .detail-info-content-list-search {
          background: #ffffff;
          padding: 20px 40px;
          width: 100%;

          .detail-info-content-list-search-item {
            height: 42px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .detail-info-content-list-search-item-title {
              font-weight: bolder;
              font-size: 15px;
              color: #1e1e1e;
            }

            .detail-info-content-list-search-item-tag {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;

              .detail-info-content-list-search-item-tag-detail {
                &+.detail-info-content-list-search-item-tag-detail {
                  margin-left: 20px;
                }

                font-weight: 400;
                font-size: 15px;
                height: 28px;
                line-height: 28px;
                box-sizing: content-box;
                color: #898989;
                padding: 0 14px;
                cursor: pointer;
                border-radius: 4px;

                &.active {
                  background: rgba(12, 106, 236, 0.1);
                  border: 1px solid #0c6aec;
                  color: #0c6aec;
                }
              }

              .detail-info-content-list-search-item-tag-city {
                margin-left: 34px;
                width: 300px;
              }
            }
          }
        }
      }

      .detail-info-content-sort {
        margin-top: 16px;
        height: 42px;
        background: rgba(12, 106, 236, 0.1);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;

        .detail-info-content-sort-left {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          .detail-info-content-sort-left-text {
            font-weight: 400;
            font-size: 15px;
            color: #1e1e1e;

            span {
              color: #0c6aec;
            }
          }

          .detail-info-content-sort-left-tab {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            border-radius: 6px;
            overflow: hidden;
            margin-left: 16px;

            .detail-info-content-sort-left-tab-item {
              height: 28px;
              padding: 0 12px;
              font-weight: 400;
              font-size: 14px;
              color: #898989;
              line-height: 28px;
              cursor: pointer;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              background: #ffffff;
              user-select: none;

              &.active {
                background: #0c6aec;
                color: #ffffff;
              }

              .detail-info-content-sort-left-tab-item-jt {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-left: 4px;

                .active-b {
                  color: #39b7ff;
                }

                .el-icon-caret-top {
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  align-items: center;

                  &::before {
                    height: 8px;
                  }
                }

                i {
                  font-size: 16px;
                }
              }
            }
          }
        }

        .detail-info-content-sort-right {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          border-radius: 8px;
          overflow: hidden;

          .detail-info-content-sort-right-tab {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .detail-info-content-sort-right-tab-item {
              height: 28px;
              padding: 0 12px;
              font-weight: 400;
              font-size: 14px;
              background: #ffffff;
              color: #898989;
              line-height: 28px;
              cursor: pointer;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;

              &.active {
                background: #0c6aec;
                color: #ffffff;
              }

              i {
                font-size: 16px;
                margin-right: 8px;
              }
            }
          }
        }
      }

      .detail-info-content-table {
        margin-top: 12px;
        margin-bottom: 78px;

        // background: #ffffff !important;
        ::v-deep {
          .table-header-own {
            font-size: 16px !important;
            color: #0c6aec !important;
            background: #ffffff !important;
          }
        }

        .detail-info-content-table-page {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin-top: 30px;
        }

        .detail-info-content-table-card {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          flex-wrap: wrap;

          .detail-info-content-table-card-item {
            width: 296px;
            height: 420px;
            background: #ffffff;
            border-radius: 8px;
            border: 1px solid #dedee5;
            margin-left: 8px;
            margin-bottom: 10px;
            overflow: hidden;
            cursor: pointer;

            &:nth-child(4n + 1) {
              margin-left: 0px;
            }

            .detail-info-content-table-card-item-img {
              width: 296px;
              height: 210px;
              background: #ebebef;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .detail-info-content-table-card-item-text {
              padding: 0 7px;

              .detail-info-content-table-card-item-text-title {
                margin-top: 16px;
                font-weight: bold;
                font-size: 18px;
                line-height: 18px;
                height: 18px;
                color: #1e1e1e;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                /* 限制行数为3 */
                overflow: hidden;
              }

              .detail-info-content-table-card-item-text-info {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                margin-top: 8px;

                .detail-info-content-table-card-item-text-title-left {
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 14px;
                  height: 14px;
                  color: #898989;
                }

                .detail-info-content-table-card-item-text-title-right {
                  font-weight: 400;
                  font-size: 14px;
                  color: #e20e0e;

                  span {
                    font-weight: bold;
                  }
                }

                .detail-info-content-table-card-item-text-title-bmjz {
                  font-weight: 400;
                  font-size: 14px;
                  color: #1e1e1e;
                }

                .detail-info-content-table-card-item-text-title-sysj {
                  font-weight: bold;
                  font-size: 14px;
                  color: #0c6aec;
                }
              }
            }

            .detail-info-content-table-card-item-button-active {
              width: 276px;
              height: 40px;
              background: #ffac37;
              text-align: center;
              line-height: 40px;
              border-radius: 8px;
              margin: 0 auto;
              margin-top: 15px;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              cursor: pointer;
            }

            .detail-info-content-table-card-item-button-unactive {
              width: 276px;
              height: 40px;
              background: #d2d2e0;
              text-align: center;
              line-height: 40px;
              border-radius: 8px;
              margin: 0 auto;
              margin-top: 15px;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}

::v-deep {
  .el-menu-vertical-demo {
    .el-submenu__title {
      font-weight: bolder;

    }

    .el-menu-item {
      &.is-active {
        font-weight: bolder;
      }
    }
  }

  .table-zt {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .table-zt-dot {
      width: 10px;
      height: 10px;
      background: #1890FF;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
.menu_item{
  font-weight: 600;
}
</style>